import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const navItems = [
  { to: '/',         label: 'Overview',  icon: '◈' },
  { to: '/insights', label: 'Insights',  icon: '◉' },
  { to: '/settings', label: 'Settings',  icon: '◎' },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);

  const handleLogout = () => { logout(); navigate('/login'); };

  return (
    <div style={{ display:'flex', height:'100vh', overflow:'hidden' }}>
      {/* Sidebar */}
      <aside style={{
        width: collapsed ? 56 : 220,
        background: 'var(--bg-card)',
        borderRight: '1px solid var(--border)',
        display: 'flex',
        flexDirection: 'column',
        transition: 'width 0.2s ease',
        flexShrink: 0,
        overflow: 'hidden'
      }}>
        {/* Logo */}
        <div style={{
          padding: collapsed ? '24px 16px' : '24px 20px',
          borderBottom: '1px solid var(--border)',
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          justifyContent: collapsed ? 'center' : 'space-between'
        }}>
          {!collapsed && (
            <div style={{ fontFamily:'var(--font-mono)', fontSize:18, fontWeight:700, color:'var(--text-primary)' }}>
              Sig<span style={{ color:'var(--accent-purple)' }}>nal</span>
            </div>
          )}
          <button
            onClick={() => setCollapsed(!collapsed)}
            style={{ background:'none', border:'none', color:'var(--text-dim)',
                     fontSize:16, padding:4 }}
          >
            {collapsed ? '▶' : '◀'}
          </button>
        </div>

        {/* Nav */}
        <nav style={{ padding: '12px 8px', flex: 1 }}>
          {navItems.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              style={({ isActive }) => ({
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                padding: '9px 12px',
                borderRadius: 6,
                marginBottom: 2,
                color: isActive ? 'var(--accent-purple)' : 'var(--text-muted)',
                background: isActive ? 'rgba(139,127,255,0.08)' : 'transparent',
                fontFamily: 'var(--font-mono)',
                fontSize: 11,
                letterSpacing: '1px',
                textDecoration: 'none',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                transition: 'all 0.15s'
              })}
            >
              <span style={{ fontSize: 16, flexShrink: 0 }}>{item.icon}</span>
              {!collapsed && item.label.toUpperCase()}
            </NavLink>
          ))}
        </nav>

        {/* User */}
        <div style={{
          padding: collapsed ? '16px 8px' : '16px 20px',
          borderTop: '1px solid var(--border)'
        }}>
          {!collapsed && (
            <div style={{ marginBottom: 8 }}>
              <div style={{ fontSize: 12, color: 'var(--text-primary)', fontWeight: 500 }}>{user?.name}</div>
              <div style={{ fontSize: 10, color: 'var(--text-dim)', fontFamily: 'var(--font-mono)' }}>
                {user?.workspaceName}
              </div>
            </div>
          )}
          <button
            onClick={handleLogout}
            style={{
              background: 'none', border: 'none',
              color: 'var(--text-dim)', fontSize: collapsed ? 16 : 11,
              fontFamily: 'var(--font-mono)', letterSpacing: '1px',
              padding: collapsed ? 4 : 0, display: 'flex', alignItems: 'center', gap: 6
            }}
          >
            {collapsed ? '⎋' : '⎋ LOGOUT'}
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main style={{ flex: 1, overflow: 'auto', background: 'var(--bg-deep)' }}>
        <Outlet />
      </main>
    </div>
  );
}
